import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getTenantConfig } from 'services/api/AccessManagerAPI';

export const useTenantConfig = (tenantId = '') => {
    const { data, isLoading, error, ...rest } = useQuery({
        queryKey: queryKeys.tenantConfig(tenantId),
        queryFn: () => getTenantConfig(tenantId),
        enabled: !!tenantId,
    });

    return { tenantConfigData: data, isTenantConfigLoading: isLoading, tenantConfigError: error, ...rest };
};
